import { type Messages } from './messages';

const en: Messages = {
  brand: {
    tagline: 'MRP // PLANNING LAYER',
  },
  status: {
    label: 'STATUS:',
    awaitingInputs: 'AWAITING INPUTS',
    ready: 'READY',
    fault: 'FAULT',
    allInputsLoaded: 'ALL INPUTS LOADED',
    requiredInputs: 'Required: BOM + (Sales or Mfg orders). Inventory and Parts optional.',
  },
  setup: {
    intro:
      'Drop your BOM, inventory, and orders. The engine collapses the multi-level BOM into time-phased purchase recommendations. Files never leave this browser.',
    parametersHeader: 'PARAMETERS',
    horizonDays: 'Horizon (days)',
    purchaseLeadDays: 'Default purchase lead (d)',
    productionLeadDays: 'Default production lead (d)',
    safetyStockPercent: 'Safety stock %',
    runEngine: 'Run engine',
    fault: 'FAULT:',
  },
  slots: {
    bom: 'BOM',
    inventory: 'INVENTORY',
    sales: 'SALES ORDERS',
    mfg: 'MFG ORDERS',
    purchase: 'PURCHASE ORDERS',
    parts: 'PARTS MASTER',
    dropHint: 'Drop CSV or click to pick',
    parsing: 'PARSING…',
    rows: 'ROWS',
    failed: 'FAILED',
    mapColumns: 'MAP COLUMNS BELOW',
  },
  mapping: {
    header: 'MAP COLUMNS',
    ready: 'READY',
    missing: 'MISSING',
    confirm: 'CONFIRM',
  },
  processing: {
    expandingBom: 'EXPANDING BOM',
    seedingDemand: 'SEEDING DEMAND',
    simulating: 'SIMULATING',
    running: 'RUNNING',
    cancel: 'Cancel',
  },
  results: {
    orders: 'ORDERS',
    newRun: 'New run',
    downloadCsv: 'Download CSV',
    nothingToBuy: 'Nothing to buy. Every demand is covered by on-hand stock.',
    colOrderBy: 'Order by',
    colSku: 'SKU',
    colDescription: 'Description',
    colHave: 'Have',
    colNeed: 'Need',
    colUom: 'UOM',
    colNeedBy: 'Need by',
    colDriving: 'Driving',
  },
  warnings: {
    quarantined: 'QUARANTINED',
    clear: 'clear',
  },
  locale: {
    chooseLanguage: 'Choose language',
  },
  toasts: {
    simFailed: 'Simulation failed',
    simNoPurchases: 'No purchases needed',
    simRecommendationCount: 'purchase recommendations',
    mapAllFirst: 'Map all required columns first',
    dismiss: 'Dismiss',
  },
  help: {
    open: 'Help',
    title: 'How beforered works',
    intro:
      'Drop your BOM, inventory, and orders. The engine expands the multi-level BOM into time-phased purchase recommendations. Files never leave your browser.',
    filesHeader: 'The files',
    requiredMark: '*',
    requiredNote: '* required. At least one of Sales or Mfg orders needed.',
    outputHeader: 'What you get back',
    outputBody:
      'One CSV per run with columns: orderByDate, sku, description, currentOnHand, suggestedQuantity, neededByDate, uom, drivingOrders, asOf. Sorted by orderByDate ascending — that row order is your to-do list.',
    tipsHeader: 'Good to know',
    tipGreenfield:
      'Starting from zero stock? Skip the Inventory file. The engine assumes zero on-hand and plans your first purchase round.',
    tipQuarantine:
      'A SKU in the warnings panel means it was on a demand or inventory row but not in any BOM or Parts row. Probably a typo or missing-data signal.',
    tipPrivacy:
      'CSV data never leaves the browser. Only the result CSV you download knows what you uploaded.',
    gotIt: 'Got it, let’s go',
    close: 'Close',
  },
  slotHelp: {
    requiredColumns: 'Required columns',
    optionalColumns: 'Optional columns',
    bom: 'One row per parent-child link in your bill of materials.',
    inventory: 'On-hand snapshot per SKU. Optional: skip to start from zero stock.',
    sales: 'Open sales orders. Each row pulls stock down on its ship date.',
    mfg: 'Existing manufacturing orders: supply on the parent SKU, smeared input demand across the production window.',
    purchase: 'Incoming purchase orders. Add supply on the delivery date.',
    parts: 'Per-SKU descriptions, UOMs, and lead times. Overrides the global defaults.',
  },
};

export default en;
